import { render, staticRenderFns } from "./extends.vue?vue&type=template&id=19acb38c&"
import script from "./extends.vue?vue&type=script&lang=js&"
export * from "./extends.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports